var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3047_2394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.75 26.5628C43.75 21.2022 46.0214 16.0923 50 12.5003L43.75 6.25032C41.3827 8.02599 38.2154 8.31159 35.5686 6.98798C32.9219 5.66488 31.25 2.95963 31.25 0.000366211H18.75C18.75 2.95974 17.0781 5.66488 14.4314 6.98798C11.7846 8.31153 8.6173 8.02601 6.25 6.25032L0 12.5003C3.97857 16.0923 6.25 21.2022 6.25 26.5628C6.25 31.9234 3.97857 37.0334 0 40.6253L6.25 46.8753C8.99743 44.3943 12.7276 43.303 16.3792 43.9108C20.0314 44.519 23.2056 46.7625 25 50.0003C26.7944 46.7624 29.9688 44.5199 33.6208 43.9108C37.2724 43.3022 41.0026 44.3943 43.75 46.8753L50 40.6253C46.0214 37.0334 43.75 31.9234 43.75 26.5628ZM25 12.5003C23.2744 12.5003 21.875 11.1009 21.875 9.37532C21.875 7.64976 23.2744 6.25032 25 6.25032C26.7256 6.25032 28.125 7.64976 28.125 9.37532C28.125 11.1009 26.7256 12.5003 25 12.5003Z",
    fill: "#495057"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3047_2394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.1c332b89758fad93833f1db65b14d859.svg";
export { ForwardRef as ReactComponent };